import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { AppInputBase } from "../../../../../shared/components/AppInputBase";
import { TrashIcon } from "../../../../../shared/icons/TrashIcon";
import styles from "./styles.module.css";

interface Props {
  className?: string;
  inputValue: string;
  inputId: string;
  onDeleteInput: (inputId: string) => void;
  onInputChange: (value: string, index: string) => void;
}

export const ClassInputContainer: React.FC<Props> = ({
  className,
  inputValue,
  inputId,
  onDeleteInput,
  onInputChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles["input-container"]}>
      <AppInputBase
        className={classNames(styles.input, className)}
        small
        rows={undefined}
        placeholder={t("classification.example_placeholder")}
        onChange={(e) => onInputChange(e.target.value, inputId)}
        value={inputValue}
      />
      <AppIconButton onClick={() => onDeleteInput(inputId)}>
        <TrashIcon />
      </AppIconButton>
    </div>
  );
};
